import { useCallback } from "react";

const useAWSUpload = () => {
  const waitForS3 = useCallback(
    async (ms, body, callback) => (
      new Promise(resolve => {
        // This timeout is to allow AWS to upload the file, in this point,
        // AWS has responded with a 200 status, but we need to take care of
        // S3 Consistency Model
        setTimeout(async () => {
          await callback(body);
          resolve(1); // Resolve the Promise after the callback is done
        }, ms);
      })
    ),
    []
  );

  return { waitForS3 };
};

export default useAWSUpload;
